var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "q-pa-md" }, [
    _c("div", { staticClass: "q-pb-sm" }, [
      _c("h6", [_vm._v(" Details ")]),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            {
              staticClass: "q-pa-md col-12",
              attrs: {
                error: _vm.validation.courseForm.COURSE_NAME.$error,
                "error-label": "Must have more than 4 characters"
              }
            },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Course Name",
                  value: _vm.courseForm.COURSE_NAME,
                  required: ""
                },
                on: {
                  blur: _vm.validation.courseForm.COURSE_NAME.$touch,
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateCourseForm({
                      field: "COURSE_NAME",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-12" },
            [
              _c("q-select", {
                attrs: {
                  chips: "",
                  multiple: "",
                  "float-label": "Associated States",
                  value: _vm.stateIds,
                  options: _vm.stateOptions
                },
                on: {
                  input: function(stateIds) {
                    return this$1.updateCourseForm({
                      field: "STATES",
                      value: stateIds.map(function(stateId) {
                        return { LK_STATE_ID: stateId }
                      })
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "q-py-sm" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            {
              staticClass: "q-pa-md col-4",
              attrs: {
                error: _vm.validation.courseForm.COURSE_LENGTH_HOURS.$error,
                "error-label": "Hours must be less than 24"
              }
            },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Hours",
                  type: "number",
                  value: _vm.courseForm.COURSE_LENGTH_HOURS,
                  required: ""
                },
                on: {
                  blur: _vm.validation.courseForm.COURSE_LENGTH_HOURS.$touch,
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateCourseForm({
                      field: "COURSE_LENGTH_HOURS",
                      value: Number.parseInt($event.target.value)
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "q-pa-md col-4",
              attrs: {
                error: _vm.validation.courseForm.COURSE_LENGTH_MINUTES.$error,
                "error-label": "Value must be less than 60"
              }
            },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Minutes",
                  type: "number",
                  value: _vm.courseForm.COURSE_LENGTH_MINUTES,
                  required: ""
                },
                on: {
                  blur: _vm.validation.courseForm.COURSE_LENGTH_MINUTES.$touch,
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateCourseForm({
                      field: "COURSE_LENGTH_MINUTES",
                      value: Number.parseInt($event.target.value)
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "q-pa-md col-4",
              attrs: {
                error: _vm.validation.courseForm.COURSE_LENGTH_SECONDS.$error,
                "error-label": "Value must be less than 60"
              }
            },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Seconds",
                  type: "number",
                  value: _vm.courseForm.COURSE_LENGTH_SECONDS,
                  required: ""
                },
                on: {
                  blur: _vm.validation.courseForm.COURSE_LENGTH_SECONDS.$touch,
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateCourseForm({
                      field: "COURSE_LENGTH_SECONDS",
                      value: Number.parseInt($event.target.value)
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row", staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "q-field",
            [
              _c("q-checkbox", {
                attrs: {
                  label: "Disable Approval Process",
                  "true-value": 1,
                  "false-value": 0
                },
                model: {
                  value: _vm.courseForm.DISABLE_APPROVAL_PROCESS,
                  callback: function($$v) {
                    _vm.$set(_vm.courseForm, "DISABLE_APPROVAL_PROCESS", $$v)
                  },
                  expression: "courseForm.DISABLE_APPROVAL_PROCESS"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            [
              _c("q-checkbox", {
                attrs: {
                  label: "Disable Payments",
                  "true-value": 1,
                  "false-value": 0
                },
                model: {
                  value: _vm.courseForm.DISABLE_PAYMENTS,
                  callback: function($$v) {
                    _vm.$set(_vm.courseForm, "DISABLE_PAYMENTS", $$v)
                  },
                  expression: "courseForm.DISABLE_PAYMENTS"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            [
              _c("q-checkbox", {
                attrs: {
                  label: "Enable NY Reports",
                  "true-value": 1,
                  "false-value": 0
                },
                model: {
                  value: _vm.courseForm.ENABLE_NY_REPORTS,
                  callback: function($$v) {
                    _vm.$set(_vm.courseForm, "ENABLE_NY_REPORTS", $$v)
                  },
                  expression: "courseForm.ENABLE_NY_REPORTS"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }